import ContainerProds from "../../Components/ContainerProds";
import { useEffect, useState } from "react";
import Header from "../../Components/Header";
import ListGroups from "../../Components/ListGrups";
import { Div } from "../../Styles/Styled";
import api from "../../services/api";
import { CircularProgress } from "@mui/material";
import { Colors, NOME_EMPRESA, PRECO_ATACADO, VIEW_GRUPO2 } from "../../config";

interface Item {
  kits?: any[];
  width: number;
  chave: number;
  descricao: string;
  preco_venda: number;
  preco_atacado?: number;
  grupo1: string;
  grupo2: string;
  grupo3: string;
  tipo: string;
  picture: string;
  unidade: string;
  observacao: string;
}

export default function Menu() {
  const [ItensPerRow, setItemsPerRow] = useState(2);
  const [loading, setLoading] = useState(false);
  const [fixed, setFixed] = useState(false);
  const [dados, setDados] = useState<Item[]>([]);
  const removeDuplicates = (dados: string[]) => {
    return dados
      ?.filter((element, index) => {
        return dados.indexOf(element) === index;
      })
      .filter((e) => e);
  };

  const FormatGruposNivel2 = (items: string[]) => {
    console.log(items);
    let result : any = {}
    items.forEach((e) => {
      const item: any = {};
      item[e] = [];
      const grupos2: string[] = [];
      dados.forEach((f) => {
        if (f.grupo1 === e) {
          if (grupos2.includes(f?.grupo2)) {
          } else if (f?.grupo2) {
            grupos2.push(f?.grupo2);
          }
        }
      });
      item[e] = grupos2;
      result = {...result, ...item}
    });
    return result;
  };

  const getProduto = async () => {
    setLoading(true);
    try {
      const result: Item[] = (await api.get("/produtos?grupo_web=1&order=DESC")).data;
      result.forEach((e) => {
        e.preco_venda =
          PRECO_ATACADO && e.preco_atacado ? e.preco_atacado : e.preco_venda;
        if (e?.tipo === "R" && e?.kits) {
          e.kits.forEach((f) => {
            if (f?.grupo_kit) {
              if (f?.grupo_kit?.produtosnv1) {
                f?.grupo_kit?.produtosnv1?.forEach((r: any) => {
                  r.preco_venda =
                    PRECO_ATACADO && r?.preco_atacado
                      ? r?.preco_atacado
                      : r?.preco_venda || 0;
                });
              }
            }
          });
        }
      });
      setDados(result);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      alert("erro ao pegar produtos, por favor recarregue");
    }
  };

  useEffect(() => {
    getProduto();
    const scroll = document;
    if (window.innerWidth >= 576 && window.innerWidth < 720) {
      setItemsPerRow(2);
    }

    if (window.innerWidth < 576) {
      setItemsPerRow(1);
    }

    if (window.innerWidth >= 720 && window.innerWidth < 960) {
      setItemsPerRow(3);
    }

    if (window.innerWidth >= 960 && window.innerWidth < 1450) {
      setItemsPerRow(4);
    }

    if (window.innerWidth >= 1450 && window.innerWidth < 1600) {
      setItemsPerRow(5);
    }

    if (window.innerWidth >= 1600) {
      setItemsPerRow(6);
    }

    function findOffset(element: any) {
      var top = 0,
        left = 0;
      do {
        top += element.offsetTop || 0;
        left += element.offsetLeft || 0;
        element = element.offsetParent;
      } while (element);
      return {
        top: top,
        left: left,
      };
    }

    const FixHeader = () => {
      const stickyHeader = document.getElementById("Produtos");
      if (!stickyHeader) return;
      const headerOffset = findOffset(stickyHeader);
      const bodyScrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (bodyScrollTop > headerOffset.top) {
        setFixed(true);
      } else {
        setFixed(false);
      }
    };

    scroll.addEventListener("scroll", FixHeader);
    document.title = NOME_EMPRESA;
    return () => {
      scroll.removeEventListener("click", FixHeader);
    };
  }, []);

  return (
    <Div background={Colors.backgroundColorApp}>
      <Header
        fixed={fixed}
        dados={
          dados[0] ? removeDuplicates(dados.map((e: any) => e.grupo1)) : []
        }
        gruposnv2={
          dados[0]
            ? FormatGruposNivel2(
                removeDuplicates(dados.map((e: any) => e.grupo1))
              )
            : []
        }
      />
      {!loading && (
        <>
          <ListGroups
            fixed={false}
            items={
              dados[0] ? removeDuplicates(dados.map((e: any) => e.grupo1)) : []
            }
            groupsnv2={
              dados[0]
                ? FormatGruposNivel2(
                    removeDuplicates(dados.map((e: any) => e.grupo1))
                  )
                : []
            }
          />
          <ContainerProds
            perRow={ItensPerRow}
            groups={
              dados[0] ? removeDuplicates(dados.map((e: any) => e.grupo1)) : []
            }
            groupsnv2={
              dados[0]
                ? FormatGruposNivel2(
                    removeDuplicates(dados.map((e: any) => e.grupo1))
                  )
                : []
            }
            items={dados}
          />
        </>
      )}

      {loading && (
        <Div Height={"70vh"} Content="center" Items="center">
          {" "}
          <CircularProgress
            size={"25vh"}
            style={{ color: Colors.loadingColor }}
          />
        </Div>
      )}
    </Div>
  );
}
